export default "/Bus06.gif";